import React, { useState, useEffect } from "react";
import { Form, Input, Button, message, Modal } from "antd";
import AuthLayout from "./index";
import AuthService from "../../../Services/AuthService";
import { UserSwitchOutlined } from "@ant-design/icons";
import { PhoneOutlined } from "@ant-design/icons";
import tqt from "../../../Assets/Icons/tqtick.jpeg";
import cytologo from "../../../Assets/logo/Doxzon Logo.svg";
import formbg from '../../../Assets/Images/formbg.png';
function CallBackForm() {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [userName, setUserName] = useState("");
    const [phone, setPhoneNum] = useState("");
    const [disable, setDisable] = useState(false);
    useEffect(() => {
        document.body.classList.add("hide-translator");
        return () => {
            document.body.classList.remove("hide-translator");
        };
    }, []);
    const handleSubmit = async () => {
        if (!userName) {
            message.error("Please Enter Doctor Name");
            return;
        }
        if (!phone) {
            message.error("Please Enter Mobile Number");
            return;
        }
        let payload = {
            "createdBy": "support@doxzon.com",
            "doctorName": userName,
            "mobile": phone,
            "modifiedBy": "support@doxzon.com"
        }
        try {
            setDisable(true);
            const res = await AuthService.CallBackApi(payload);
            if (res.data.data === 1) {
                setVisible(true)
                form.resetFields();
                setDisable(false);
                setTimeout(() => {
                    setUserName("")
                    setPhoneNum("")
                    setVisible(false)
                }, 3000)
            } else {
                message.error("An Error occured. Please Try Again");
                setDisable(false);
            }
        } catch (error) {
            message.error("An Error occured. Please Try Again");
            setDisable(false);
        }
    };

    return (
        <div
            className="h-screen"
            style={{
                backgroundImage: `url(${formbg})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
            }}
        >
            <div>
                <div className="min-h-screen flex flex-col justify-center items-center w-screen h-screen">
                    <div
                        className="md:w-[32%] w-[85%] bg-white flex flex-col justify-start items-center shadow-xl border rounded-xl py-6"
                        style={{ margin: "0 auto" }}
                    >
                        <div className="mt-2 flex flex-col gap-1 justify-center items-center">
                            <img src={cytologo} alt="logo" className="w-32 h-10" />
                            <span className="text-[12px]">Technology for health</span>
                        </div>
                        <div className="mt-6 w-[85%] bg-white border rounded-xl shadow-md px-6 py-6">

                            <Form
                                name="basic"
                                layout="vertical"
                                autoComplete="off"
                                form={form}
                                onFinish={handleSubmit}
                            >
                                <Form.Item
                                    name="userName"
                                    label="Name"
                                    colon={false}
                                    required={false}
                                    rules={[
                                        { required: true, message: "Name is required" }
                                    ]}
                                >
                                    <div className="relative">
                                        <Input
                                            value={userName}
                                            onChange={(e) => setUserName(e.target.value)}
                                            placeholder="Doctor Name"
                                            className="h-10 w-full px-2  border-[1px] border-gray-400 appearance-none bg-none dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                            style={{ background: "none" }}
                                            prefix={
                                                <UserSwitchOutlined className="h-5 w-5 text-gray-500" />
                                            }
                                        />
                                    </div>
                                </Form.Item>
                                <Form.Item
                                    name="mobileNumber"
                                    label="Contact Number"
                                    colon={false}
                                    required={false}
                                    rules={[
                                        { required: true, message: "Mobile number is required" },
                                        { pattern: /^\d{10}$/, message: "Mobile number must be 10 digits" },
                                    ]}
                                >
                                    <div className="relative">
                                        <Input
                                            value={phone}
                                            placeholder="Mobile Number"
                                            className="h-10 w-full px-2 mt-2 border-[1px] border-gray-400 appearance-none bg-none dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                            style={{ background: "none" }}
                                            maxLength={10}
                                            onKeyDown={(e) => {
                                                const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                                                if (allowedKeys.includes(e.key)) return;
                                                if (!/^[0-9]$/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onChange={(e) => {
                                                const digitsOnly = e.target.value.replace(/\D/g, "");
                                                setPhoneNum(digitsOnly);
                                            }}
                                            prefix={
                                                <PhoneOutlined className="h-5 w-5 text-gray-500" />
                                            }
                                        />
                                    </div>
                                </Form.Item>
                                <Form.Item>
                                    <button
                                        htmlType="submit"
                                        className="w-full mt-3 font-semibold text-white rounded-md h-10 bg-[#189FAA]"
                                        disabled={disable}
                                    >
                                        Request a call back
                                    </button>
                                </Form.Item>

                            </Form>
                        </div>
                        <Modal
                            open={visible}
                            onCancel={() => {
                                setVisible(false);
                                setUserName("");
                                setPhoneNum("");
                            }}
                            footer={null}
                            centered
                        >
                            <div className="flex flex-col items-center text-center p-6">
                                <img src={tqt} alt="logo" className="w-36 h-36" />
                                <p className="mt-4 text-[16px]">Our team will contact you shortly.</p>
                            </div>
                        </Modal>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default CallBackForm;
